import { h4, h5, p2, p3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  gap: 16px;
  padding: 18px 16px;

  border-radius: ${themeStyle.radiusLarge};

  box-shadow: ${themeStyle.varShadowSmallFocus};
  background-color: ${themeStyle.varBackgroundAlt};

  background-image: url('/images/liquid.svg');
  background-repeat: no-repeat;

  background-position: -290px 0;

  ${QUERIES.tabletAndUp} {
    background-position: -92px 0;
  }

  ${QUERIES.laptopAndUp} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding: 32px;

    background-position: 0;
  }

  html[data-theme='dark'] &&,
  .dark && {
    background-image: url('/images/liquidDark.svg');
  }
`;

export const Heading = styled.h4`
  ${h5};

  font-weight: ${themeStyle.fontBold};

  ${QUERIES.largeTabletAndUp} {
    ${h4};
  }
`;

export const Description = styled.p`
  ${p3};

  ${QUERIES.largeTabletAndUp} {
    ${p2};
  }
`;
